const STORAGE_KEY = 'viewed_prize_ids';

export function getViewedPrizeIds(): Set<number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as number[]);
  } catch {
    return new Set();
  }
}

export function markPrizeViewed(id: number): void {
  const ids = getViewedPrizeIds();
  ids.add(id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
}

export function getUnviewedPrizes<T extends { id: number }>(prizes: T[]): T[] {
  const viewed = getViewedPrizeIds();
  return prizes.filter(p => !viewed.has(p.id));
}
